import { GoogleAnalytics, GoogleTagManager } from "@next/third-parties/google";
import { NextPage } from "next";
import { NextIntlClientProvider } from "next-intl";
import type { AppProps } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import type { ReactElement, ReactNode } from "react";
import { nunito } from "utils/fonts";
import "../styles.css";
import TermlyRouteSync from "@/components/TermlyRouteSync";

const googleAnalyticsId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID;

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

export default function MyApp({ Component, pageProps }: AppPropsWithLayout) {
  const router = useRouter();
  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <>
      <TermlyRouteSync />
      <main className={nunito.className}>
        <Head>
          <meta name="viewport" content="initial-scale=1, width=device-width" />
        </Head>

        <NextIntlClientProvider
          locale={router.locale}
          messages={pageProps.messages}
          timeZone="Europe/Lisbon"
        >
          {getLayout(<Component {...pageProps} />)}
        </NextIntlClientProvider>
        <GoogleAnalytics gaId={googleAnalyticsId} />
        <GoogleTagManager gtmId="GTM-KDNGNHCH" />
      </main>
    </>
  );
}
